import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

const Alert = ({header, body, isOpen, toggleAlert}) =>
    <Modal isOpen={isOpen} toggle={toggleAlert} fade={false}>
        <ModalHeader toggle={toggleAlert}>{header}</ModalHeader>
        <ModalBody>
            {typeof body !== 'undefined' ? body.length > 1 ? <ul className={"errs-list"}>{body.map((line, i) => (<li key={i}>{line}</li>))}</ul> : body[0] : null}
        </ModalBody>
        <ModalFooter>
            <Button color="primary" onClick={toggleAlert}>Ok</Button>
        </ModalFooter>
    </Modal>

export default Alert;


// WEBPACK FOOTER //
// ./src/app/components/Alert.js